// @ts-nocheck
// grapqhl codegen doesn't generate the correct types when using aliases in query

import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import type { Dayjs } from 'dayjs'
import priceFormatter from '@barchart/marketdata-api-js/lib/utilities/format/price'

import { BalanceBy } from '@graphql'

dayjs.extend(relativeTime)

type TDate = Date | string | undefined

export const formatDate = (date: TDate, format: string = 'MM/DD/YYYY') => {
  if (date) return dayjs(date).format(format)
  return '-'
}

export const formatDateWithTime = (date: TDate) => {
  return formatDate(date, 'MM/DD/YYYY hh:mma')
}

export const formatExpirationDate = (date: TDate) => {
  return formatDate(date, 'YYYY-MM-DD')
}

export const formatDeliveryDate = (date: TDate) => {
  return formatDate(date, 'MMM YY')
}

export const formatNumber = (number: number | undefined) => {
  if (number || number === 0)
    return number?.toLocaleString(undefined, { maximumFractionDigits: 2 })
  return null
}

export const formatPrice = (price: number, unitCode: number) => {
  if (!price) return '-'
  return priceFormatter(price, unitCode, '-', true)
}

export const formatCashPrice = (
  price?: number | null,
  roundAt?: number | null
) => {
  if (!price) return '-'

  let formattedPrice = price.toString()

  if (roundAt) {
    const remainder = ((price - Math.floor(price * 100) / 100) * 100).toFixed(2)
    formattedPrice =
      remainder >= roundAt
        ? (Math.ceil(price * 100) / 100).toFixed(2)
        : (Math.floor(price * 100) / 100).toFixed(2)
  }
  return formattedPrice
}

export const formatBasis = (basis?: number | null) => {
  if (basis === 0) return '-.00'
  if (!basis) return '-'
  let formattedBasis = basis.toFixed(2)

  if (Math.abs(basis) < 1) {
    formattedBasis = formattedBasis.replace(/^(-?)0\./, '$1.')
  }

  return formattedBasis
}

export const fromNowOrNow = (date: Dayjs) => {
  return Math.abs(dayjs().diff(date)) < 25000
    ? 'just now'
    : dayjs(date).fromNow()
}

type CSVData = {
  Account: string
  Commodity: string
  Type: string
  Location: string
  Amount: string
}

export const formatBalancesForCSV = (balancesBy: BalanceBy[]) => {
  const csvData: CSVData[] = []
  balancesBy?.forEach(account => {
    const commodities = account?.commodities as BalanceBy[]
    commodities?.forEach(commodity => {
      const locations = commodity?.locations as BalanceBy[]
      locations?.forEach(location => {
        const data = location?.positions?.map(position => {
          return {
            Account: account.id,
            Commodity: commodity?.name,
            Type: position?.name,
            Location: location?.name,
            Amount: formatNumber(position?.amount as number)
          }
        })
        csvData.push(data)
      })
    })
  })
  return csvData.flat()
}
